import { render, staticRenderFns } from "./route-pagination.vue?vue&type=template&id=6edc6fa0&scoped=true"
import script from "./route-pagination.vue?vue&type=script&lang=js"
export * from "./route-pagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edc6fa0",
  null
  
)

export default component.exports